import DEBUG from "@/store/debug.js";

export default async ({ commit, state }) => {
    DEBUG("GET_SEQUESTRE_MOVEMENTS_START");
    if (state.sequestreMovementsInit && !state.sequestreMovementsLoading) {
        try {
            commit("SET_SEQUESTRE_MOVEMENTS_LOADING", true);
            const sequestreMovementsRes = await window.app.$api.getSequestreMovements();
            const sequestreMovements = sequestreMovementsRes.data;
            DEBUG("GET_SEQUESTRE_MOVEMENTS_SUCCESS");
            commit("SET_SEQUESTRE_MOVEMENTS", sequestreMovements);
            return sequestreMovements;
        } catch (e) {
            DEBUG("GET_SEQUESTRE_MOVEMENTS_ERROR");
            window.app.$ui.error(e, "my_transactions_movements_transactions");
            throw e;
        } finally {
            commit("SET_SEQUESTRE_MOVEMENTS_LOADING", false);
        }
    } else {
        DEBUG("GET_SEQUESTRE_MOVEMENTS_BYPASSED");
        return state.sequestreMovements;
    }
};
